import React, {Proptype, Component} from 'react';
import classnames from 'classnames';
import Dropzone from 'react-dropzone';
import ImageCropper from 'template/Modals/ImageCropper';
import imageUploader from 'controllers/mediaCenter/imageUploader';
import { alert } from 'util/alert';
import { Circle } from 'rc-progress';
import Loading from 'components/UI/Loading'
import locale from './locale';
import MediaList from './MediaList';
import './Modal.scss';

const ACCEPT_MIME = 'image/png,image/jpeg';
const MAX_SIZE = 5 * 1024 * 1024;
const MIN_SIZE = 0;

class DefaultTab extends Component {
  constructor(props){
    super(props)

    this.state = {
      uploading: false,
      progress: '0',
    }

    this.selectImage = this.selectImage.bind(this)
    this.increaseProgressBar = this.increaseProgressBar.bind(this)
  }

  selectImage(accepted, rejected){
    const schoolId = localStorage.getItem('schoolId')

    if (rejected.length > 0) {
      alert.warning(__('Image file must be png/jpeg under 5 MB', 'image'), __('Image not qualified', 'image'));
      return;
    } else if (accepted.length === 0) {
      alert.warning('', __('No Image Selected'));
      return;
    }

    this.setState({uploading: true})
    // Option 1
    // this.startProgressBar()

    imageUploader(schoolId, accepted[0])
    .then((res) => {
      // Option 1 below commented
      // clearTimeout(this.tm);
      this.props.selectedIndexChange(1)
      this.setState({uploading: false})
    })
  }

  // Option 1 function
  increaseProgressBar(){
    const progress = this.state.progress + 3;
    if(progress > 100){
      clearTimeout(this.tm);
      return;
    }

    this.setState({progress})
    this.tm = setTimeout(this.increaseProgressBar, 5)
  }

  // Option 1 function
  startProgressBar(){
    clearTimeout(this.tm);
    this.setState({progress: 0}, () => {
      this.increaseProgressBar();
    })
  }

  render(){
    const {mediaState} = this.props
    const {uploading, progress} = this.state

    if(mediaState == 'upload'){
      return(
        <div>
          {!uploading && <a>
            <Dropzone
              accept={ACCEPT_MIME}
              multiple={false}
              className='MediaCenter--dropzone'
              maxSize={MAX_SIZE}
              minSize={MIN_SIZE}
              onDrop={this.selectImage}
              children={
                <div className='container-overlay'>
                  <div className='text'>
                    <h3>{__('Click or drag and drop image here', 'schoolInformation.form')}</h3>
                    <h5>{__('Max file size: 5 MB', 'schoolInformation.form')}</h5>
                  </div>
                </div>
              }
            />
          </a>}
          {/* Option 1: Using progress bar */}
          {/* {uploading && <div><Circle percent={progress} strokeWidth="4" strokeColor="#346aff"></Circle></div>} */}

          {/* Options 2: Using Loading */}
          {uploading && <div className='loading-container'>
            <Loading />
            <p>{__('Uploading...', locale)}</p>
          </div>}
        </div>
      )
    } else if (mediaState == 'list'){
      return(
        <MediaList mediaState='list' selectMultiple={this.props.selectMultiple} onFormChange={this.props.onFormChange} />
      )
    } else if (mediaState == 'public'){
      return (
        <MediaList mediaState='public' selectMultiple={this.props.selectMultiple} onFormChange={this.props.onFormChange} />
      )
    }
  }
}


export default (DefaultTab)



// WEBPACK FOOTER //
// ./src/template/Modals/MediaCenter/DefaultTab.js